import { BACKTOPANEL, CHANGE_BACKTOPANEL } from 'src/State-Management/Actions/ActionTypes'

const BackToPanelReducer = function (state = false, action) {
    switch (action.type) {
        case BACKTOPANEL:
            return state;
        case CHANGE_BACKTOPANEL:
            return action.payload;
        default:
            return state;
    }
}

export default BackToPanelReducer